import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { makeStyles, Button, Typography } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  ellipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
}));

const LoginStepThree = ({
  onClick,
  username,
  requestedToken,
}) => {
  const classes = styles();

  return (
    <div>
      <Typography variant="h6" paragraph className={classes.ellipsis}>
        <FormattedMessage
          id="welcome.welcomeBack"
          defaultMessage="Welcome back"
        />{' '}{username}
      </Typography>
      {
        !requestedToken && (
          <>
            <Typography>
              <FormattedMessage
                id="welcome.userIsSoft"
                defaultMessage="Your account doesn't have a password set. Click on the button below and we will send you an email with a link to login into your account."
              />
            </Typography>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => onClick(username)}
              type="button"
            >
              <FormattedMessage
                id="Continue"
                defaultMessage="Continue"
              />
              <ChevronRight />
            </Button>
          </>
        )
      }
      {
        requestedToken && (
          <>
            <Typography>
              <FormattedMessage
                id="welcome.tokenRequested"
                defaultMessage="An email has been sent. Use the link in the email to login into your account"
              />
            </Typography>
          </>
        )
      }
    </div>
  );
};

LoginStepThree.propTypes = {
  onClick: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  requestedToken: PropTypes.bool.isRequired,
};

export default LoginStepThree;
